import React from 'react';
const Search = ({onChange, inputRef, onKeyUp, value}) => {
    return(
        <div className="map-filter-inner">
            <input type="text" id="filter-input" name="filter" placeholder="Filter by name" aria-label="Filter by name" value={value} autoComplete="off" onKeyUp={onKeyUp}  onChange={onChange} ref={inputRef}/>
        </div>
    )
}
export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js